import React from 'react';
import PropTypes from 'prop-types';

import Head from 'nordic/head';

const Metatata = (props) => {
  const { metadata } = props;

  return (
    <Head>
      <title>{metadata.title}</title>
      <meta name="description" content={metadata.description} />
    </Head>
  );
};

Metatata.propTypes = {
  metadata: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
};

export default Metatata;
